import React from 'react';

import { L10n } from '~src/commonInfra/L10n/L10n';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

export interface Timestamp {
  label: string;
  value: Date;
}

export function Timestamp(props: Timestamp) {
  return (
    <>
      <dt className={DetailsTooltipStyles.DescriptionTerm}>{ props.label }</dt>
      <dd className={DetailsTooltipStyles.DescriptionDetails}>{ L10n.localizedDateTime(props.value) }</dd>
    </>
  );
}

